import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Container from "@material-ui/core/Container";
import axios, { AxiosResponse, AxiosError } from "axios";
import { observer } from "mobx-react-lite";
import { configure } from "mobx";
import { Routes } from "./routes/routes";
import { AuthorizationRoute } from "./AuthorizationRoute";
import { Auth } from "./features/Auth/Auth";
import { useStyles } from "./App.styles";
import { MainPage } from "./components/MainPage/MainPage";
import { getRefreshToken } from "./helpers/cookies";
import { Notifier } from "./features/Notifier/Notifier";
import { authStore } from "./mobx/stores/AuthStore/AuthStore";

setTimeout(() => {
  configure({
    enforceActions: "never",
    reactionScheduler: (f) => {
      setTimeout(f, 1);
    },
  });
}, 1);

axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    return Promise.reject(error.response);
  }
);

const App = observer(() => {
  const classes = useStyles();
  const { isLogged, refreshToken } = authStore;

  useEffect(() => {
    if (!isLogged) {
      const token = getRefreshToken();
      if (token) {
        refreshToken(token);
      }
    }
  }, [isLogged]);

  return (
    <Container className={classes.root} disableGutters maxWidth={false}>
      <Notifier />
      <BrowserRouter>
        <Switch>
          <Route path={`/${Routes.login}`} component={Auth} />
          <Route path={`/${Routes.register}`} component={Auth} />
          <AuthorizationRoute component={MainPage} />
        </Switch>
      </BrowserRouter>
    </Container>
  );
});

export default App;
